import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterTabs from './FilterTabs';
import { getAllAppliedFilters } from '../../../../../../helpers/utils';
import { getQueryStr, getUrlParamsMapV2 } from '../../../../../../../common/utils/browserUtils';
import { getMMT_HLD_OBJ } from '../../../../../../../common/utils/appUtils';
import { THEMES_FILTER_NAME } from '../../../../../../constants/filterConstants';

const AppliedFilters = ({ handleClearAllFilters, listingFilters, handleFilterChange }) => {
  const [search] = useSearchParams();

  const appliedFilters = useMemo(
    () => getAllAppliedFilters(listingFilters, search),
    [listingFilters, search]
  );

  useEffect(() => {
    const themes =
      appliedFilters.find(filter => filter.urlParam === THEMES_FILTER_NAME)?.currentFilterValue ||
      [];
    const params = getUrlParamsMapV2();
    if (themes.length > 0 || params.mcat || params.campaign) {
      if (params.campaign) themes.push(params.campaign);
      params.mcat = [...new Set(themes)].join(',');
      const paramsStr = getQueryStr(params);
      // eslint-disable-next-line no-undef
      if (ssr.isOnClient && !getMMT_HLD_OBJ().fromSEO) {
        const { origin, pathname } = window.location;
        window.history.replaceState(null, null, `${origin}${pathname}?${paramsStr}`);
      }
    }
  }, [appliedFilters]);

  return appliedFilters?.length ? (
    <div className="filterTabsWrapper">
      {appliedFilters?.map(filterValue => (
        <FilterTabs
          filterValue={filterValue}
          key={`${filterValue?.urlParam}_${filterValue?.optionData?.uniqueId}`}
          handleFilterChange={handleFilterChange}
        />
      ))}
      {!!appliedFilters?.length && (
        <span className="clearAll" onClick={handleClearAllFilters}>
          Clear All
        </span>
      )}
    </div>
  ) : null;
};

export default AppliedFilters;
